module.exports = __webpack_public_path__ + "static/media/Madeira.ceaa5dae.svg";